import React from "react";
import "./index.scss";

const ErrorMessage = ({ className = '' }) => {
	return (
		<>
			<div className={`error-msg-blc text-center d-flex align-items-center justify-content-center h-100 ${className}`}>
				<div className="inner">
					<h2>Transcripts Requested:</h2>
					<p>
						IRS Transcripts are now  in the pending status.
						<span>Status will be updated, and transcripts will be displayed upon receipt.</span>
					</p>
					<div className="pic">
						<img className="img-fluid" src={require('../../../assets/img/doc-pic.png')} />
					</div>
				</div>
			</div>
		</>
	);
}

export default ErrorMessage;